import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { FiGrid, FiPackage, FiShoppingBag } from 'react-icons/fi';

const SidebarContainer = styled(Box)(({ theme }) => ({
  width: '110px',
  backgroundColor: '#ffffff',
  borderRight: '1px solid #f0f0f0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'fixed',
  left: 0,
  top: 0,
  height: '100vh',
  zIndex: 100,
  paddingTop: '72px',
}));

const NavSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '6px',
  width: '100%',
  padding: '24px 16px',
}));

const NavItem = styled(Box)(({ theme, isActive }) => ({
  width: '70px',
  height: '70px',
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  position: 'relative',
  color: isActive ? '#3b82f6' : '#94a3b8',
  backgroundColor: isActive ? 'rgba(59, 130, 246, 0.08)' : 'transparent',
  
  '&:hover': {
    backgroundColor: isActive ? 'rgba(59, 130, 246, 0.12)' : 'rgba(241, 245, 249, 0.8)',
  },
  
  '& svg': {
    fontSize: '22px',
    marginBottom: '6px',
  },
  
  '&::after': isActive ? {
    content: '""',
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '24px',
    height: '3px',
    backgroundColor: '#3b82f6',
    borderRadius: '1.5px',
  } : {},
}));

const NavLabel = styled('span')(({ theme, isActive }) => ({
  fontSize: '11px',
  fontWeight: isActive ? '600' : '500',
  color: isActive ? '#3b82f6' : '#64748b',
}));

const LeftSidebar = ({ tabs = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Tabs stay here in LeftSidebar component
  const defaultTabs = [
    { label: "Orders", path: "/admin/orders", icon: FiShoppingBag },
    { label: "Products", path: "/admin/products", icon: FiPackage },
    { label: "Dashboard", path: "/admin/dashboard", icon: FiGrid },
    
    
  ];

  const navTabs = tabs.length > 0 ? tabs : defaultTabs;

  const handleTabClick = (path) => navigate(path);

  const isTabActive = (path) => 
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <SidebarContainer>
      <NavSection>
        {navTabs.map((tab) => {
          const Icon = tab.icon;
          const active = isTabActive(tab.path);
          return (
            <NavItem 
              key={tab.path} 
              isActive={active} 
              onClick={() => handleTabClick(tab.path)}
            >
              <Icon />
              <NavLabel isActive={active}>{tab.label}</NavLabel>
            </NavItem>
          );
        })}
      </NavSection>
    </SidebarContainer>
  );
};

export default LeftSidebar;